"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import dayjs from "dayjs";

/**
 * Директива "project-table"
 * @return {{restrict: string, template: *, transclude: boolean, scope: {selectedItem: string, items: string, type: string, filters: string, ok: string, isPaging: string, isSearch: string, isFilter: string}, controller: [string,string,string,string,string,string,string,string,null]}}
 */
export default function () {
  return {
    restrict: "A",
    template: require("../view/table.html"),
    transclude: true,
    scope: {
      selectedItem: "=?myValue",
      items: "=?myItems",
      type: "@myType",
      filters: "=?myFilters",
      localFilter: "=?myLocalFilter",
      ok: "=?myOk",
      isPaging: "=myPagination",
      isSearch: "=mySearching",
      isFilter: "=myFilter",
      searchFilterRequestParams: "=?mySearchFilterRequestParams",
    },
    controller: [
      "$rootScope",
      "$scope",
      "$utils",
      "$uibModal",
      "ProjectService",
      "PhaseService",
      "Notification",
      "$location",
      "$security",
      "$log",
      function (
        $rootScope,
        $scope,
        $utils,
        $modal,
        ProjectService,
        PhaseService,
        Notification,
        $location,
        $security,
        $log
      ) {
        setTimeout(() => {
          console.log("tyt", $scope.items);
        }, 3000);
        $scope.refresh = refresh;
        $scope.dblClick = dblClick;
        $scope.doublelClickOpen = doublelClickOpen;
        $scope.select = select;
        $scope.isSelect = isSelect;
        $scope.getItems = getItems;
        $scope.getMunicipality = getMunicipality;
        $scope.getSignDate = getSignDate;
        $scope.statistic = {
          totalItems: 0,
          totalCost: 0,
          totalPayment: 0,
          totalWplaces: 0,
        };

        $scope.getValue = $utils.getValue;

        $scope.sorting = new Map([
          ["code", "DESC"],
          //["name", "ASC"],
        ]);

        $scope.setSorting = function (column) {
          // Если столбец тот же, меняем направление
          const newValue = $scope.sorting.get(column) === "ASC" ? "DESC" : "ASC";
          $scope.sorting.clear();
          $scope.sorting.set(
            column,
            newValue
          );

          $scope.refresh();
        };

        $scope.checkColumn = function (columnName, equal) {
          return columnName === equal;
        };

        $scope.getPhase = function (phase) {
          if ($scope.phases) {
            const phases = $scope.phases;

            const foundPhase = phases.find((item) => item.shortName === phase);

            if (foundPhase) {
              return foundPhase.name;
            } else {
              return "нет данных";
            }
          }
        };

        let enableDelete = false;
        let query = null;
        let queryPhases = null;
        let queryForStatistic = null;

        init();

        // region Functions

        /**
         * Инициализация
         */
        function init() {
          $scope.loading = true;

          if (!$scope.selectedItem) {
            $scope.selectedItem = ProjectService.getSelectItem();
          }

          $scope.columns = [
            {
              name: "Этап",
              data: "currentStage",
            },
            {
              name: "Код",
              data: "code",
            },
            {
              name: "Текущий этап",
              data: "phase.name",
              type: "percent",
              style: (item) => {
                let value =
                  item.phase != null
                    ? "background: linear-gradient(90deg, #ecf0f5 0%, #ecf0f5 " +
                      item.percent +
                      "%, transparent " +
                      item.percent +
                      "%, transparent 100%);"
                    : "";

                $log.debug("COLUMN:STYLE:", value);

                return value;
              },
              ngStyle: (item) => {
                let value =
                  item.phase != null
                    ? {
                        background:
                          "linear-gradient(90deg, #ecf0f5 0%, #ecf0f5 " +
                          item.percent +
                          "%, transparent " +
                          item.percent +
                          "%, transparent 100%);",
                      }
                    : {};

                $log.debug("COLUMN:NG-STYLE:", value);

                return value;
              },
            },
            {
              name: "Инициатор",
              data: "author",
              sortable: true,
            },
            {
              name: "Краткое наименование проекта",
              data: "shortName",
              sortable: true,
              // type: 'href',
              // href: (item) => {
              //     return 'projects/' + item.id;
              // }
            },
            {
              name: "Объем инвестиций в проект, млн. руб.",
              data: "investments",
              sortable: true,
            },
            {
              name: "Количество рабочих мест",
              data: "workPlaces",
              sortable: true,
            },
            {
              name: "Муниципальное образование",
              data: "municipality",
              type: "municipality",
              sortable: true,
            },
            {
              name: "Площадка проекта",
              data: "area",
            },
          ];

          const searchingStorage = sessionStorage.getItem("searching");
          console.log(document.referrer.includes("projects"), searchingStorage);
          if ($rootScope.isFromProjectPage) {
            console.log("www");
          }
          $scope.searching = {
            isSearch: $scope.isSearch,
            filter:
              $rootScope.isFromProjectPage && searchingStorage
                ? searchingStorage
                : null,
          };

          $scope.pagination = ProjectService.getPagination();

          // тулбокс таблицы
          $scope.toolbox = {
            // кнопки на панели управления
            buttons: {
              // создание
              create: {
                show: () => $security.isAllowWrite("/projects", "create"),
                click: () => {
                  ProjectService.create().result.then((data) => {
                    ProjectService.api.create(null, { form: data }, (data) => {
                      ProjectService.edit(data._embedded);
                    });
                  });
                },
                disabled: () => false,
              },
              // редактирование
              edit: {
                show: () => isSelected(),
                click: (item) => ProjectService.edit(item),
                disabled: () =>
                  $scope.selectedItem == null || $scope.selectedItem.id == null,
              },
              // удаление
              // remove: {
              //     show: () => isSelected() && ($security.isAllowWrite('/projects', 'delete')),
              //     click: (item) => {
              //         ProjectService.remove(item, (data) => $scope.refresh());
              //     },
              //     disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null || !enableDelete,
              // },
              // переместить в корзину
              moveToTrash: {
                show: () => isSelected() && enableDelete,
                click: (item) => {
                  ProjectService.moveToTrash(item, (data) => $scope.refresh());
                },
                disabled: () =>
                  $scope.selectedItem == null ||
                  $scope.selectedItem.id == null ||
                  !enableDelete,
              },
              // обновление таблицы
              refresh: {
                show: () => true,
                click: $scope.refresh,
                disabled: () => false,
              },
            },
          };

          // получение данных
          //refresh();
        }

        /**
         * Получение всех записей
         * @return {*}
         */
        function getItems() {
          return $scope.items;
        }

        function getMunicipality(item) {
          const res = Array.isArray(item?.municipality)
            ? item.municipality.join(", ")
            : "";
          return res;
        }

        /**
         * Выбрал ли элемент!
         * @param {*} item проверяемый элемент
         * @return {bool}
         */
        function isSelect(item) {
          return equals(getSelected(), item);
        }

        /**
         * Выбрать элемент
         * @param {*} item выбираемый элемент
         */
        function select(item) {
          if (!$scope.isSelect(item)) {
            enableDelete = false;
            angular.copy(item, $scope.selectedItem);
            ProjectService.api.enableDelete({ projectId: item.id }, (data) => {
              enableDelete = data._embedded;
            });
          } else {
            angular.copy({}, $scope.selectedItem);
          }
          ProjectService.setSelectItem($scope.selectedItem);
        }

        /**
         * Двойное нажатие на запись в таблице
         * @param {*} item данные записи
         */
        function dblClick(item) {
          switch ($scope.type) {
            case "table":
              if ($scope.toolbox.buttons.edit) {
                $scope.toolbox.buttons.edit.click(item);
              }
              break;
            case "select":
              $scope.ok();
              break;
          }
        }

        function doublelClickOpen(item) {
          $scope.toolbox.buttons.edit.click(item);
        }

        /**
         * Получение фильтров
         * @return {Array}
         */
        function getFilters() {
          let filters = angular.copy($scope.localFilter);

          if (Array.isArray($scope.filters)) {
            filters = filters.concat($scope.filters);
          }

          // if (!!$scope.localFilter.hasExpirationMaintenance) {
          //     if ($scope.localFilter.hasExpirationMaintenance === 'EXPIRED') {
          //         filters.push(`'hasExpirationMaintenance' EQ 'true'`);
          //     } else if ($scope.localFilter.hasExpirationMaintenance === 'NOT_EXPIRED') {
          //         filters.push(`'hasExpirationMaintenance' EQ 'false'`);
          //     }
          // }

          // if (Array.isArray($scope.localFilter.industry) && $scope.localFilter.industry.length) {
          //     filters.push(`EXTRA:'industry' EQ '${$scope.localFilter.industry.map(n => "" + n.id).join(';')}'`);
          // }

          // if (!!$scope.localFilter.milestone) {
          //     filters.push(`EXTRA:'milestone' EQ '${$scope.localFilter.milestone}'`);
          // }
          // else  {
          //     let myMilestone = $scope.localFilter.milestones.find((el) => el.name === 'Реализованные')

          //     if (myMilestone)
          //         filters.push(`EXTRA:'milestone' NE '${myMilestone.id}'`)
          // }

          //filters.push(`'entityStatus' EQ 'ENABLED'`);
          return filters;
        }

        /**
         * Получение поиска
         * @return {Array}
         */
        function getSearchs() {
          let searchs = [];
          if ($scope.isSearch) {
            if (
              $scope.searching.filter != null &&
              !($scope.searching.filter.length < 1)
            ) {
              searchs.push(
                `'shortName':'${$scope.searching.filter}'`,
                `'name':'${$scope.searching.filter}'`,
                `'code':'${$scope.searching.filter}'`,
                `'author.shortName':'${$scope.searching.filter}'`,
                `'author.fullName':'${$scope.searching.filter}'`
              );
            }
          }

          $scope.searchFilterRequestParams = searchs;

          return searchs;
        }

        /**
         * Выбрана ли запись
         * @return {boolean}
         */
        function isSelected() {
          return (
            $scope.selectedItem != null &&
            !angular.equals($scope.selectedItem, {})
          );
        }

        /**
         * Проверка элементов на равенство
         * @param {*} i1
         * @param {*} i2
         * @return {*}
         */
        function equals(i1, i2) {
          return angular.equals(i1, i2);
        }

        /**
         * Получить выбранный элемент
         * @return {{}|*}
         */
        function getSelected() {
          return $scope.selectedItem;
        }

        function getSignDate(item) {
          return item.signDate
            ? dayjs(item.signDate).format("DD.MM.YYYY")
            : "нет данных";
        }

        function prettyStatisticValue(value) {
          console.log(value);
          return value
            ? value
                .toLocaleString("ru-RU", { maximumFractionDigits: 2 })
                .replace(",", ".")
            : 0;
        }

        /**
         * Обновить данные таблицы
         */
        function refresh() {
          $scope.loading = true;

          console.log(Array.from($scope.sorting));

          // Определяем параметр sorts на основе выбранной сортировки
          const sortsParam = Array.from($scope.sorting).map((item) =>
            item.join(":")
          );

          console.log(getFilters(), getSearchs());
          query = ProjectService.api.getAll(
            {
              filters: getFilters(),
              searchs: getSearchs(),
              sorts: sortsParam,
              page: $scope.pagination.page,
              size: $scope.pagination.size,
            },
            function (data) {
              console.log("request", data);
              $scope.items = data._embedded.items || [];
              $scope.statistic = {
                totalCost: prettyStatisticValue(
                  data._embedded.totalCost / 1000
                ),
                totalPayment: prettyStatisticValue(
                  data._embedded.totalPayment / 1000
                ),
                totalWplaces: prettyStatisticValue(data._embedded.totalWplaces),
                totalItems: data.page ? data.page.totalElements : 0,
              };
              if (isSelected()) {
                if ($scope.items.every((i) => i.id != getSelected().id)) {
                  $scope.selectedItem = {};
                } else {
                  angular.copy(
                    $scope.items.find((i) => i.id == getSelected().id),
                    $scope.selectedItem
                  );
                }
              }
              if ($scope.pagination.isPaging) {
                $scope.pagination.totalPages = data.page.totalPages;
                $scope.pagination.totalItems = data.page.totalElements;
              }

              $scope.loading = false;
            }
          );

          queryPhases = PhaseService.api.getAll(
            {
              sorts: ["npp:ASC", "name:ASC"],
            },
            function (data) {
              $scope.phases = data._embedded;
            }
          );
        }

        /**
         * Статистика
         */
        function statistic() {
          queryForStatistic = ProjectService.api.getStatistic(
            {
              filters: getFilters(),
              searchs: getSearchs(),
              sorts: ["code:DESC", "shortName:ASC", "name:ASC"],
              page: 1,
              size: null,
            },
            function (data) {
              $scope.statistic = data._embedded;
            }
          );
        }

        // endregion

        // region Watchers

        // $scope.$watchGroup(['filters', 'hasExpirationMaintenance', 'milestone', 'milestones'], function(_n, _o, scope) {
        //     console.log(_n, _o)
        //     console.log(angular.equals(_n, _o))
        //     if (angular.equals(_n, _o) || !$scope.milestones.length) return;
        //     refreshRequest(scope);
        // });

        $scope.$watch(
          "filters",
          function (nw, old) {
            if (angular.equals(nw, old)) return;
            refreshRequest();
          },
          true
        );

        $scope.$watch(
          "localFilter",
          function (nw, old) {
            if (!nw.length) return;
            refreshRequest();
          },
          true
        );

        $scope.$watch(
          "searching",
          function (nw, old) {
            if (nw?.filter) {
              sessionStorage.setItem("searching", nw?.filter);
            } else {
              sessionStorage.setItem("searching", "");
            }
          },
          true
        );

        // $scope.$watch('hasExpirationMaintenance', function (nw, old) {
        //     if (angular.equals(nw, old)) return;
        //     refreshRequest();
        //     console.log('hasExpirationMaintenance')
        // });

        // $scope.$watch('industry', function (nw, old) {
        //     if (angular.equals(nw, old)) return;
        //     refreshRequest();
        //     console.log('industry')
        // }, true);

        // $scope.$watch('milestone', function (nw, old) {
        // if (angular.equals(nw, old)) return;
        //     refreshRequest();
        //      console.log('milestone')
        // });

        // $scope.$watch('milestones', function (nw, old) {
        // if (angular.equals(nw, old)) return;
        //     refreshRequest();
        //     console.log('milestones')
        // });

        function refreshRequest() {
          if (query) {
            query.$cancelRequest();
            query = null;
          }

          // if (queryPhases) {
          //   queryPhases.$cancelRequest?.();
          //   queryPhases = null;
          // }

          if (queryForStatistic) {
            queryForStatistic.$cancelRequest();
            queryForStatistic = null;
          }

          $scope.refresh();
        }

        // endregion
      },
    ],
  };
}
